"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9832],{

/***/ 83900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowDown = function SvgArrowDown(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 256,
        height: 256,
        viewBox: "0 0 256 256"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        d: "M0 66.73c0 2.66.981 5.33 2.955 7.41l117.332 123.323a10.64 10.64 0 0 0 7.712 3.314c2.912 0 5.696-1.19 7.712-3.314L253.043 74.14c4.074-4.278 3.914-11.077-.331-15.163a10.627 10.627 0 0 0-15.083.333L128 174.536 18.379 59.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76 10.76 0 0 0 0 66.73"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowDown);


/***/ }),

/***/ 12357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ whats_new_items_list_embedded_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/pages/whats-new/whats-new-items-list-component/whats-new-items-list.js + 8 modules
var whats_new_items_list = __webpack_require__(1681);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/whats-new-items-list-embedded/whats-new-items-list-embedded-component.scss.js


var StyledWhatsNewItemsListEmbeddedComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e9jao2m0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;");

// EXTERNAL MODULE: ./segments/desktop/embedded/layouts/whats-new-items-list-embedded/consts.js
var consts = __webpack_require__(10055);
// EXTERNAL MODULE: ./components/pages/whats-new/utils.js
var utils = __webpack_require__(29621);
;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/whats-new-items-list-embedded/whats-new-items-list-embedded-component.js





var WhatsNewItemsListEmbeddedComponent = function(props) {
    var _mondayConfigToUse_data_boards__items_page, _mondayConfigToUse_data_boards_, _mondayConfigToUse_data_boards, _mondayConfigToUse_data;
    var productFilterValue = props.productFilterValue, hideProductFilter = props.hideProductFilter, tmp = props.dynamicProps, mondayConfig = (tmp === void 0 ? {} : tmp).mondayConfig;
    var mondayConfigToUse = mondayConfig || consts/* staticMondayConfig */.f;
    var items = mondayConfigToUse === null || mondayConfigToUse === void 0 ? void 0 : (_mondayConfigToUse_data = mondayConfigToUse.data) === null || _mondayConfigToUse_data === void 0 ? void 0 : (_mondayConfigToUse_data_boards = _mondayConfigToUse_data.boards) === null || _mondayConfigToUse_data_boards === void 0 ? void 0 : (_mondayConfigToUse_data_boards_ = _mondayConfigToUse_data_boards[0]) === null || _mondayConfigToUse_data_boards_ === void 0 ? void 0 : (_mondayConfigToUse_data_boards__items_page = _mondayConfigToUse_data_boards_.items_page) === null || _mondayConfigToUse_data_boards__items_page === void 0 ? void 0 : _mondayConfigToUse_data_boards__items_page.items;
    var itemsArrayObj = (0,utils/* createItemsArray */.Su)(items);
    var itemsArray = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.itemsArray) || [];
    var monthlyVideosSet = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.monthlyVideosSet) || {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhatsNewItemsListEmbeddedComponent, {
        className: "whats-new-items-list-embedded-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(whats_new_items_list/* default */.Z, {
            itemsArray: itemsArray,
            productFilterValue: productFilterValue,
            monthlyVideosSet: monthlyVideosSet,
            hideProductFilter: hideProductFilter
        })
    });
};
/* harmony default export */ var whats_new_items_list_embedded_component = (WhatsNewItemsListEmbeddedComponent);


/***/ })

}]);